module.exports = {"jwtCookieName":"__spruce_radstar_jwt_token","tinyMCEApiKey":"h34zotvov1xz0q2kjowpo8x5hbc37mprjhebxrsn4s55eail","version":"1.3.0"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = ./src/config.json
// module chunks = 1